// Shared API utility for authenticated requests
// Handles both cookie-based and localStorage token-based auth
// Works reliably across custom domains where cookies may not persist

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function getStoredToken() {
  return localStorage.getItem('session_token');
}

export function authHeaders() {
  const token = getStoredToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

export async function apiFetch(path, options = {}) {
  const token = getStoredToken();
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(`${API}${path}`, {
    ...options,
    headers,
    credentials: 'include',
  });
}

// For file uploads (FormData - don't set Content-Type)
export async function apiUpload(path, formData) {
  const token = getStoredToken();
  const headers = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(`${API}${path}`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: formData,
  });
}
